import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useInterpolatedSerieCubicSpline } from '../series/use-interpolated-serie-cubic-spline';
import type { KeyboardLike, KeyWith } from '@/lib/piano/keyboard';
import { generateCustomFrontWeightKeypoints } from '@/lib/piano/touch-design/generate-custom-front-weight-keypoints';
export const useFrontWeightCurve = keyboard => {
  const $ = _c(8);
  const {
    generateCubicInterpolatedKeyboardSerie,
    interpolateStandardKeypointsToKeyboardSize
  } = useInterpolatedSerieCubicSpline(keyboard);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== generateCubicInterpolatedKeyboardSerie || $[2] !== interpolateStandardKeypointsToKeyboardSize) {
    t1 = new Map(t0.map(level => [level, generateCubicInterpolatedKeyboardSerie(interpolateStandardKeypointsToKeyboardSize(generateCustomFrontWeightKeypoints(Number(level))))]));
    $[1] = generateCubicInterpolatedKeyboardSerie;
    $[2] = interpolateStandardKeypointsToKeyboardSize;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const smoothedFrontWeightCurves = t1;
  let t2;
  if ($[4] !== smoothedFrontWeightCurves) {
    t2 = level_0 => smoothedFrontWeightCurves.get(level_0);
    $[4] = smoothedFrontWeightCurves;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const getFrontWeightCurve = t2;
  let t3;
  if ($[6] !== getFrontWeightCurve) {
    t3 = {
      getFrontWeightCurve
    };
    $[6] = getFrontWeightCurve;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};